import { Injectable } from "@angular/core";
import { BehaviorSubject, map, Observable, of, tap, throwError } from "rxjs";
import { Country } from "../common/countries.model";
import { Services } from "./api.service";

@Injectable({
  providedIn: 'root'
})
export class CountriesStore {
  private readonly countriesSubject$ = new BehaviorSubject<Country[]>([]);
  public countries$ = this.countriesSubject$.asObservable();

  constructor(private readonly apiService: Services) {}

  fetchCountries(): Observable<Country[]> {
    const cachedData = this.countriesSubject$.getValue();
    if (cachedData.length > 0) {
      return of(cachedData);
    }

    return this.apiService.getListOfCountries().pipe(
      map(response => {
        if (!response.success) {
          throwError(() => new Error());
        }
        return response.data;
      }),
      tap(countries => this.countriesSubject$.next(countries))
    );
  }

  getCountryNameById(id: number): string {
    const country = this.countriesSubject$.getValue().find(country => country.id === id);
    return country?.name ?? '';
  }
}